import { useState, useCallback } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import useInstallPrompt from '../hooks/useInstallPrompt';

const DISMISS_KEY = 'lc_install_dismissed';

// "INSTALL APP" NON STA PIU' SOPRA NIENTE (2026-09-11).
//
// Era un pulsante `position:fixed` in basso a sinistra, con z-index 200: nel
// flusso non occupava niente, quindi la pagina gli finiva sotto. Misurato a
// 390px sul vault: copriva a meta' la scheda del piano gratuito. Il rimedio
// precedente — sommare l'altezza della barra in basso al suo `bottom` — lo
// spostava solo piu' su, dove copriva qualcos'altro.
//
// Adesso e' una riga a tutta larghezza sopra la barra in basso, e SPINGE il
// contenuto invece di coprirlo: misura la propria altezza e la pubblica come
// --ltc-install-h, che App.css somma allo spazio in fondo alle pagine. E'
// la stessa cosa che fanno gia' la barra dell'offerta (--banner-h) e la barra
// delle icone (--ltc-dock-h); si misura invece di scriverla a mano perche'
// il testo va a capo a larghezze diverse e i telefoni hanno safe-area diverse.
//
// L'ALTERNATIVA SCARTATA era una icona nell'intestazione accanto al profilo:
// non copre niente per costruzione, ma un'icona muta fra le altre non la
// nota nessuno, e questa riga e' l'unico posto da cui si installa l'app.
//
// Chiudibile come prima, e chiusa resta chiusa: stessa chiave in
// localStorage, quindi chi l'aveva gia' chiusa non la rivede.
// L'ALTEZZA NON SI PUBBLICA PIU' (2026-09-12). Da quando l'invito e' una
// pillola in basso a destra larga quanto il suo contenuto, non occupa una
// fascia e non c'e' niente da riservare: --ltc-install-h resta indefinita e
// i `var(--ltc-install-h, 0px)` sparsi in App.css valgono 0 da soli. Era una
// barra a tutta larghezza, ed era giusto riservarle lo spazio; adesso quello
// spazio era solo un buco in fondo alla pagina.
export default function InstallPrompt() {
  const { t } = useTranslation('common');
  const { standalone, ios, canInstall, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });

  const dismiss = useCallback(() => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch {}
  }, []);

  const visibile = !standalone && !dismissed && (canInstall || ios);

  if (!visibile) return null;

  return (
    <div className="lc-install-riga" role="region" aria-label={t('install_aria')}>
      {canInstall ? (
        <button className="lc-install-btn" onClick={promptInstall}>
          <span aria-hidden="true">⬇️</span> {t('install_btn')}
        </button>
      ) : (
        <span className="lc-install-testo">
          <Trans t={t} i18nKey="install_ios" components={{ 1: <strong />, 3: <strong /> }} />
        </span>
      )}
      <button
        type="button"
        className="lc-install-close"
        onClick={dismiss}
        aria-label={t('install_dismiss')}>✕</button>
    </div>
  );
}
